

import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import AsnModule from "@/store/modules/asn";
import { AsnImportHistory, AsnImportHistoryResponse } from "@/models/api/asn/history";
import { getModule } from "vuex-module-decorators";


const asnModule = getModule(AsnModule);

@Component
export default class ImportHistoryModal extends Vue {


    IsLoading: boolean = false;
    History: Array<AsnImportHistory> = [];
    Page: number = 1;
    PageSize: number = 20;
    TotalItemCount: number = 0;
    
    async created() {
        this.IsLoading = true;
        let result = await asnModule.getHistory(this.Page);
        this.Page++;
        this.IsLoading = false;
        this.History = result.history;
        this.TotalItemCount = result.totalItemCount;
    }

    async onClickImportHeader(importHeaderId){
        this.$emit('import-header', importHeaderId);
    }

    async onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
        if (Math.ceil(scrollTop) + 1 + clientHeight >= scrollHeight && !this.IsLoading && this.History.length < this.TotalItemCount)
        {
            this.IsLoading = true;
            let result = await asnModule.getHistory(this.Page);
            this.Page++;
            this.History = this.History.concat(result.history);
            this.IsLoading = false;
        }
    }
}
